import Button from '@rockalingua/ui/components/Button/Button';

import type { SurveyActionProps } from '../../types/surveyAction';

export default function CtaAction({ survey, onSubmit }: SurveyActionProps) {
  return (
    <Button
      type="primary"
      href={survey.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onSubmit}
    >
      {survey.buttonText}
    </Button>
  );
}
